import { createPortalPair } from "lib/portals"
import { HeaderBarRight } from "slot-definitions"

const [UndoPortal, UndoLive] = createPortalPair("Undo")

HeaderBarRight.plug(<UndoPortal priority={-250} />)

export { UndoLive }
